import React, {Component} from 'react';
import Moment from 'react-moment';
import './RepeatedTenderEvent.css';

class RepeatedTenderEvent extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        data: {
            tenderId: 1,
            tenderNumber: '0017',
            rate: 130,
            timestamp: (new Date()).toString()
        }
    };

    render() {
        const { data, ...state } = this.state;
        return (
            <div className="widget-notifications-item">
                <div className="widget-notifications-title text-warning font-size-13">Повторная заявка</div>
                <div className="widget-notifications-description font-size-13">Вам была отправлена повторная заявка по <a href="#">тендеру № <strong>{data.tenderNumber}</strong></a> со сниженной рекомендованной ставкой в <strong>{data.rate} руб.</strong>: <a href="#"><i className="fa fa-check"></i> принять</a> или <a href="#"><i className="fa fa-calculator"></i> указать свою ставку</a>?</div>
                <div className="widget-notifications-date font-size-12">
                    <Moment fromNow locale="ru">{data.timestamp}</Moment>
                </div>
                <div className="widget-notifications-icon fa fa-repeat bg-warning"></div>
            </div>
        );
    }
}

export default RepeatedTenderEvent;


// WEBPACK FOOTER //
// ./src/pages/EventsFeed/RepeatedTenderEvent.js